import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef } from 'react';
import Api from '../../../../_helpers/Api';
import { trans } from '../../../../_providers/Translation';

//images
import docIcon from '../../../../assets/img/icons/document.png';
import closeIcon from '../../../../assets/img/icons/close.png';
import loader from '../../../../assets/img/loader.svg';
import Success from '../../../modals/messages/Success';
import Error from '../../../modals/messages/Error';
import Dropdown from '../../../partials/Dropdown';
import Input from '../../../partials/Input';
import moment from 'moment';

function ActivateSubscription(props, ref) {

    const defaultData = {
        date: new Date()
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        loading: false,
        id: null,
        data: defaultData
    });

    const [validations, setValidations] = useState(null);

    const successModalRef = useRef(null);
    const errorModalRef = useRef(null);
    const inputModelsRef = useRef(null);

    useImperativeHandle(ref, () => ({
        open: (id) => {
            handleShow(id);
        },
        hide: () => {
            handleHide();
        }
    }));

    const handleShow = (id = null) => {
        setPopup(prev => ({
            ...prev,
            id: id,
        }));

        show();
    }

    const handleHide = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            id: null,
            data: defaultData,
        }));

        setValidations(null);

        hide().then(() => {
            if (typeof props.onClose === 'function') {
                props.onClose();
            }
        });

    }

    const show = async () => {
        return new Promise((resolve, reject) => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
            }));

            setTimeout(() => {
                setPopup(prev => ({
                    ...prev,
                    overlay: true,
                    modal: true
                }));

                return resolve();
            }, 50);
        });
    }

    const hide = async () => {
        return new Promise((resolve, reject) => {
            setPopup(prev => ({
                ...prev,
                modal: false,
                loading: false,
            }));

            setTimeout(() => {
                setPopup(prev => ({
                    ...prev,
                    overlay: false,
                    modal: false,
                }));

                return resolve();
            }, 50);
        });
    }

    const handleSave = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = 'contractors/subscriptions/activate';

        let data = new FormData(e.target);

        data.append('id', popup.id);

        Api.post(url, data)
            .then(res => {
                let modal = successModalRef.current;

                hide().then(() => {
                    modal.open();
                });

                modal.onClose(() => {
                    handleHide(e);

                    if (typeof props.onSave === 'function') {
                        props.onSave(res.data);
                    }
                });
            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }


    const handleInputChange = e => {
        let name = e.target.name;
        let val = e.target.value;

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    return (
        <>
            <Success
                ref={successModalRef}
                mainMessage={trans('messages.success')}
            />

            <Error
                ref={errorModalRef}
                mainMessage={trans('messages.fail')}
            />

            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                    <h2 className="head">
                        <img src={docIcon} alt="document" className="document-icon" />

                        {trans('headings.activateSubscription')}
                        <img src={closeIcon} alt="close" className="close-icon" onClick={handleHide} />
                    </h2>

                    <div className="popup-container">
                        <div className="col x2">
                            <label>
                                {trans('labels.fromDate')}
                            </label>
                            <Input
                                type="date"
                                name="date"
                                value={popup.data.date ? moment(popup.data.date).format('YYYY-MM-DD') : ''}
                                onChange={handleInputChange}
                                error={Boolean(validations && validations.date && (validations.date[0] || validations.date))}
                                helperText={validations && validations.date && (validations.date[0] || validations.date)}
                                style={{
                                    width: '100%'
                                }}
                            />
                        </div>
                    </div>

                    <div className="footer align-center">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div>
        </>
    )
}

export default forwardRef(ActivateSubscription);